const SocketDispatcher = Symbol.for('SocketDispatcher');

export default SocketDispatcher;
